import { getApiEnvironment } from '@innovyze/stylovyze/lib/utils/getApiEnvironment';
import { getService } from '@innovyze/stylovyze/lib/utils/getService';
import { axiosWithHeaders } from '@innovyze/stylovyze/lib/utils/axiosGenerator';
import config from './config.api';
export const amUploadBaseURL = getService('amUpload', config, getApiEnvironment());
const auth = axiosWithHeaders({
    service: 'amUpload',
    config,
    injectTenantId: false,
});
export default auth;
